/* unplugin-vue-components disabled */import script from "./StudyMaterialList.vue?vue&type=script&setup=true&lang=ts"
export * from "./StudyMaterialList.vue?vue&type=script&setup=true&lang=ts"

import "./StudyMaterialList.vue?vue&type=style&index=0&id=02a3a56e&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-02a3a56e"]])

export default __exports__